export const validateTelegramUsername = (_: unknown, value: string): Promise<void> => {
  if (!value || value.trim() === '') {
    return Promise.resolve();
  }

  let username = value.trim();
  if (username.startsWith('@')) {
    username = username.slice(1);
  }

  const usernameRegex = /^[a-zA-Z][a-zA-Z0-9_]{4,31}$/;

  if (usernameRegex.test(username)) {
    return Promise.resolve();
  }

  return Promise.reject(
    new Error(
      'Invalid Telegram username. Must be 5-32 characters, start with a letter, and contain only letters, numbers, and underscores'
    )
  );
};
